module.exports = __webpack_public_path__ + "img/selected4-min.ab500cfd.png";